import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../styles/Dashboard.css";
import { MdStorage } from "react-icons/md";
import { FaChartBar } from "react-icons/fa";
import { FaStopwatch } from "react-icons/fa";
import { IoSettingsSharp } from "react-icons/io5";
import { FaUserCircle } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { FaLink } from "react-icons/fa";
import DatenSection from "./DatenSection";
import AnalyseSection from "./AnalyseSection";
import AccountSection from "./AccountSection";
import EinstellungenSection from "./EinstellungenSection";
import ConnectionsSection from "./ConnectionsSection";
import TimeTrackingSection from "./TimeTrackingSection";

const logo = "/images/Icon.svg"; 


const Dashboard = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const requestedSection = searchParams.get("section");
  const [activeSection, setActiveSection] = useState(
    ["daten", "analyse", "zeit", "connections", "account", "einstellungen"].includes(requestedSection)
      ? requestedSection
      : "daten"
  );

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("accountType");
    navigate("/"); // or "/login" depending on your route
  };

  return (
    <div className="dashboard-container">
      <div className="header">
        <div className="header-left">
          <div className="logo-container">
            <img src={logo} alt="Festzeltfinanzen Logo" className="logo" />
          </div>
          <h1 className="header-title">Festzeltfinanzen</h1>
        </div>
        <div className="header-right">
          <button className="logout-button" onClick={handleLogout}>
            <FiLogOut/>
            Logout
          </button>
        </div>
      </div>
      <div className="dashboard-body">
        <div className="sidebar-container">
          <div className="sidebar top">
            <button
              className={`sidebar-button ${activeSection === "daten" ? "active" : ""}`}
              title="Daten"
              onClick={() => setActiveSection("daten")}
            >
              <MdStorage size={24} />
              <span className="sidebar-label">Daten</span>
            </button>
            <button
              className={`sidebar-button ${activeSection === "analyse" ? "active" : ""}`}
              title="Analyse"
              onClick={() => setActiveSection("analyse")}
            >
              <FaChartBar size={24} />
              <span className="sidebar-label">Analyse</span>
            </button>
            <button
              className={`sidebar-button ${activeSection === "zeit" ? "active" : ""}`}
              title="Zeitnotizen"
              onClick={() => setActiveSection("zeit")}
            >
              <FaStopwatch size={24} />
              <span className="sidebar-label">Zeiten</span>
            </button>
            
          </div>
          <div className="sidebar bottom">
            <button
              className={`sidebar-button ${activeSection === "connections" ? "active" : ""}`}
              title="Connections"
              onClick={() => setActiveSection("connections")}
            >
              <FaLink size={24} />
              <span className="sidebar-label">Kontakte</span>
            </button>
            <button
              className={`sidebar-button ${activeSection === "account" ? "active" : ""}`}
              title="Account"
              onClick={() => setActiveSection("account")}
            >
              <FaUserCircle size={24} />
              <span className="sidebar-label">Account</span>
            </button>
            <button
              className={`sidebar-button ${activeSection === "einstellungen" ? "active" : ""}`}
              title="Einstellungen"
              onClick={() => setActiveSection("einstellungen")}
            >
              <IoSettingsSharp size={24} />
              <span className="sidebar-label">Vorlagen</span>
            </button>
          </div>
        </div>
        <div className="main-content">
          {activeSection === "daten" && <DatenSection />}
          {activeSection === "analyse" && <AnalyseSection />}
          {activeSection === "zeit" && <TimeTrackingSection />}
          {activeSection === "connections" && <ConnectionsSection />}
          {activeSection === "account" && <AccountSection />}
          {activeSection === "einstellungen" && <EinstellungenSection />}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
